const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'investment-investment-1a',
		text: `<b>Future Business A/S overvejer at bruge penge på nye projekter</b>.
			<br /><br />Hvad betyder det at investere?`,
		hintText: `Pengene bliver ikke gemt – de bliver sat i noget, der gerne skal vokse og give mere tilbage.`,
		popupText: `Det her er grundtanken bag investeringer, som man arbejder med på HHX.`,
		image: 'hhx-investment-investment-1a',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'At gemme penge',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'At bruge penge for at tjene flere senere', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At betale regninger',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At spare op uden risiko',
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'investment-investment-1b',
		lockedById: 'investment-investment-1a',
		text: `Hvorfor investerer virksomheder overhovedet?`,
		hintText: `Formålet handler om fremtiden – at gøre virksomheden større, stærkere eller mere indtjenende over tid.`,
		image: 'hhx-investment-investment-1b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'For at bruge penge'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'For at undgå skat',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'For at skabe vækst og fremtidig indtjening', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'For at følge konkurrenterne',
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		title: 'Opgave 1C',
		taskId: 'investment-investment-1c',
		lockedById: 'investment-investment-1b',
		text: `<b>Ledelsen kan vælge at investere i flere ting</b>.
			<br /><br />Ikke alle investeringer er lige sikre.
			<br /><br />Sorter i <b>jeres bedste bud</b> på lav risiko og høj risiko.`,
		hintText: `<b>Lav risiko</b> er typisk forbedringer af det, virksomheden allerede kender. 
			<br /><br /><b>Høj risiko</b> er det, der er nyt, uprøvet eller afhænger af nye kunder og markeder.`,
		popupText: `Det her er kernen i, hvordan man lærer at vurdere risiko og investeringer på HHX.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'low-risk', 
				title: `Lav risiko`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'high-risk', 
				title: `Høj risiko`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Opgradering af IT-udstyr`,
				categoryIds: ['low-risk']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Uddannelse af medarbejdere`,
				categoryIds: ['low-risk']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Nyt kontorudstyr`,
				categoryIds: ['low-risk']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Nyt marked i udlandet`,
				categoryIds: ['high-risk']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Nye forretningsideer`,
				categoryIds: ['high-risk']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, 
				text: `Lancering af nye produkter`,
				categoryIds: ['high-risk']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 1D',
		taskId: 'investment-investment-1d',
		lockedById: 'investment-investment-1c',
		text: `Hvorfor kan ledelsen alligevel vælge at tage den høje risiko når de tager beslutninger?`,
		hintText: `Højere risiko vælges typisk, når potentialet for gevinst og vækst også er større.`,
		popupText: `Det her viser, hvordan HHX arbejder med afvejningen mellem risiko og afkast i ledelsesbeslutninger.`,
		image: 'hhx-investment-investment-1d',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Med større risiko følger ofte større mulighed for at tjene flere penge', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Der er aldrig fordele ved at øge risikoen',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Ledelsen kan godt lide spænding og usikkerhed',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Det er ligegyldigt, hvor stor risikoen er',
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 5,
		title: 'Opgave 1E',
		taskId: 'investment-investment-1e',
		lockedById: 'investment-investment-1d',
		text: `Future Business A/S har netop ansat jer fordi I arbejder med dette på HHX.
			<br /><br />Hvad lærer man især at forstå som giver værdi for virksomheden?`,
		hintText: `Det handler om at kunne balancere risiko og gevinst – ikke om at undgå risiko helt eller vælge blindt.`,
		image: 'hhx-investment-investment-1e',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'At undgå alle risici',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'At vurdere risiko i forhold til mulig gevinst', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At investere uden at tænke',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At vælge den billigste løsning',
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 6,
		title: 'Opgave 2',
		taskId: 'investment-investment-2',
		text: `<b>Nogle investeringer giver hurtigt resultat – andre senere</b>.
			<br /><br />Sorter i <b>kort sigt</b> og <b>lang sigt</b>.`,
		hintText: `<b>Kort sigt</b> giver effekt hurtigt i hverdagen. 
			<br /><br /><b>Lang sigt</b> handler om udvikling og vækst over tid.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'short-term', 
				title: `Kort sigt`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'long-term', 
				title: `Lang sigt`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Reklame på sociale medier`,
				categoryIds: ['short-term']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Nyt kontorudstyr`,
				categoryIds: ['short-term']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Udvikling af ny løsning`,
				categoryIds: ['long-term']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Opbygning af nyt marked`,
				categoryIds: ['long-term']
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 7,
		title: 'Opgave 3',
		taskId: 'investment-investment-3',
		text: `<b>En investering starter et sted</b>.
			<br /><br />Sorter trinnene i den rigtige rækkefølge.`,
		hintText: `<b>Før der handles</b>, opstår en idé, som skal vurderes. 
			<br /><br />Først <b>derefter</b> træffes en beslutning – og <b>resultaterne kommer til sidst</b>.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Idé opstår`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2,
				text: `Risiko vurderes`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3,
				text: `Beslutning træffes`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4,
				text: `Investeringen gennemføres`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5,
				text: `Resultater viser sig`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 8,
		title: 'Opgave 4',
		taskId: 'investment-investment-4',
		text: `<b>Hvis Future Business A/S vil ind på et nyt marked</b>.
			<br /><br />Hvad sker der så i hvilken rækkefølge?
			<br /><br /><b>Sorter trinnene</b>.`,
		hintText: `Før virksomheden kan vokse, skal markedet forstås og løsningen tilpasses. 
			<br /><br />Salg og vækst kommer først efter, der er investeret.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Undersøg markedet`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2,
				text: `Tilpas løsningen`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3,
				text: `Investér i opstart`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4,
				text: `Start salget`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5,
				text: `Virksomheden vokser`,
				correctOrderNumbers: [5]
			})
		]
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'investment-finance-1',
		text: `Future Business A/S vil investere, men mangler penge.
			<br /><br /><b>Hvad betyder det at finansiere?</b>`,
		hintText: `Det handler om at finde pengene, før investeringen kan gennemføres.`,
		popupText: `Finansiering er en grundsten i den måde HHX arbejder med investeringer på.`,
		image: 'hhx-investment-finance-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'At spare penge'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'At skaffe penge til investeringer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At betale skat'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At investere uden risiko'
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'investment-finance-2',
		text: `<b>Ledelsen fortæller jer at de har brug for penge til et nyt projekt.</b>
			<br /><br />Hvilken mulighed er finansiering?`,
		hintText: `Finansiering handler om at skaffe <b>kapital udefra</b> - ikke om at ændre driften her og nu.`,
		image: 'hhx-investment-finance-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'At sælge flere ydelser'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'At låne penge i banken', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At arbejde hurtigere'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At skære ned på medarbejdere'
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'investment-finance-3',
		text: `<b>Der findes forskellige måder at finansiere på.</b>
			<br /><br />Sorter i <b>egen finansiering</b> og <b>lånefinansiering</b>.`,
		hintText: `<b>Spørg jer selv:</b> Kommer pengene fra <b>virksomheden selv</b> - eller <b>udefra</b>, hvor de skal betales tilbage?`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'self-financing', 
				title: `Egen finansiering`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'loan-financing', 
				title: `Lånefinansiering`
			})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Opsparet overskud`,
				categoryIds: ['self-financing']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Penge virksomheden allerede har`,
				categoryIds: ['self-financing']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Banklån`,
				categoryIds: ['loan-financing']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Kredit`,
				categoryIds: ['loan-financing']
			})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		title: 'Opgave 4A',
		taskId: 'investment-finance-4a',
		text: `Når man låner penge, skal man betale ekstra for at låne dem.
			<br /><br />Kaldes det <b>Afkast</b>, <b>Rente</b> eller <b>Dækning</b>?<b>(skriv det rigtige svar)</b>`,
		hintText: `Det er prisen for at låne penge – den procent, man betaler oveni lånet.`,
		answer: 'Rente',
		subtype: 'string',
		altAnswers: ['renter'],
		unit: null,
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		title: 'Opgave 4B',
		taskId: 'investment-finance-4b',
		lockedById: 'investment-finance-4a',
		text: `<b>Finansiering har både fordele og ulemper.</b>
			<br /><br />Sorter udsagnene i <b>fordele</b> og <b>ulemper</b>.`,
		hintText: `<b>Fordele</b> giver virksomheden flere muligheder her og nu. 
			<br /><br /><b>Ulemper</b> er det, der binder virksomheden fremadrettet.`,
		popupText: `Her lærer man, at finansiering på HHX altid handler om at veje muligheder op mod konsekvenser.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'pros', 
				title: `Fordele`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'cons', 
				title: `Ulemper`
			})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Hurtig vækst`,
				categoryIds: ['pros']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Kan investere nu`,
				categoryIds: ['pros']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Gæld`,
				categoryIds: ['cons']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Renter`,
				categoryIds: ['cons']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Øget risiko`,
				categoryIds: ['cons']
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 6,
		title: 'Opgave 5A',
		taskId: 'investment-finance-5a',
		text: `<b>Ledelsen beslutter at de vil låne penge i banken.</b>
			<br /><br />Sorter forløbet i jeres bud på den rigtige rækkefølge.`,
		hintText: `Før pengene kan udbetales, skal behovet være klart, valget truffet, banken kontaktet og lånet vurderet.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Behov for penge opstår`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2,
				text: `Finansierings metode besluttes`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3,
				text: `Banken kontaktes`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4,
				text: `Lån vurderes og godkendes`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5,
				text: `Pengene udbetales`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 7,
		title: 'Opgave 5B',
		taskId: 'investment-finance-5b',
		lockedById: 'investment-finance-5a',
		text: `<b>Fra finansiering til investering.</b>
			<br /><br />Sorter trinnene korrekt.`,
		hintText: `Før noget kan gennemføres, skal pengene være på plads. Udvikling sker undervejs, og vurdering kommer til sidst.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Finansiering skaffes`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2,
				text: `Investering gennemføres`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3,
				text: `Projektet udvikles`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4,
				text: `Resultat evalueres`,
				correctOrderNumbers: [4]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 8,
		title: 'Opgave 6',
		taskId: 'investment-finance-6',
		text: `<b>Future Business A/S kan hjælpe kunder på forskellige måder.</b>
			<br /><br />Sorter i kræver investering og kræver ikke investering.`,
		hintText: `Noget <b>koster</b> virksomheden penge nu eller senere. 
			<br /><br />Andet handler mere om <b>måden</b>, man arbejder på.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'investment', 
				title: `Kræver investering`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'no-investment', 
				title: `Kræver ikke investering`
			})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Lang betalingsfrist`,
				categoryIds: ['investment']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Rabat for større køb`,
				categoryIds: ['investment']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Hurtig leverance`,
				categoryIds: ['no-investment']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `God kundeservice`,
				categoryIds: ['no-investment']
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 9,
		title: 'Opgave 7A',
		taskId: 'investment-finance-7a',
		text: `<b>Ledelsen overvejer at give længere betalingsfrist til kunderne.</b>
			<br /><br />Sorter beslutningen i den rigtige rækkefølge.`,
		hintText: `Før der aftales noget, skal ønsket være kendt og risikoen vurderes. 
			<br /><br />Pengene kommer først bagefter.`,
		image: 'hhx-investment-finance-7a',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1,
				text: `Kunden ønsker fleksibilitet`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2,
				text: `Ledelsen vurderer risiko`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3,
				text: `Betalingsfrist aftales`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4,
				text: `Pengene modtages senere`,
				correctOrderNumbers: [4]
			})
		]	
		
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 10,
		title: 'Opgave 7B',
		taskId: 'investment-finance-7b',
		lockedById: 'investment-finance-7a',
		text: `<b>Future Business hjælper en kunde ved at give længere betalingsfrist.</b>
			<br /><br />Hvad er den største risiko?`,
		hintText: `Risikoen handler om pengestrømmen – ikke om kundens humør eller vækst.`,
		popupText: `Her bliver HHX-logikken tydelig: pengene først.`,
		image: 'hhx-investment-finance-7b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Kunden bliver glad'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Pengene kommer senere – eller slet ikke', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Virksomheden vokser'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Opgaven bliver lettere'
			})
		]
	})
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'hhxedu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};